import React from 'react';
import Headerr from '../components/layout/header';
import Navbar from '../components/layout/navbar';
import Notificationsec from '../sections/notificationsec';
import './notification.css'
import { useState } from 'react';
import { useEffect } from 'react';
import Preloader from '../components/common/preloader';



const Notifications = () => {

                  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Preloader />

    return (  
        <>
                        <main className='home-background'>

                    <Headerr />
                    <Notificationsec />
                    <Navbar />

            </main>
        </>
    );
}
 
export default Notifications;